export const SSPA = {
  layoutId: "#single-spa-layout",
  loaderId: "#sspa-launcher-loader",
  loaderAppInfoImage: "#sspa-launcher-loader-image",
  loaderAppInfoName: "#sspa-launcher-loader-name",
  launcherSidenav: "#sspa-launcher-sidenav",
  overlay: "#sspa-overlay",
  main: "#sspa-main",
  mobileWindowWidth: 959,
};
